import { StoreActionApi } from 'react-sweet-state';

import { getProgressForCourses } from 'src/services/http/progress';
import { ProgressState } from 'src/store/progress/progressStore';
import { User } from 'src/types';
import { ContentfulLearningPath } from 'src/graphql/queries/GetLearningPath';

export const fetchProgressForCourses =
  (learningPath: ContentfulLearningPath | undefined, user: User | null | undefined) =>
    async ({ setState }: StoreActionApi<ProgressState>): Promise<void> => {
      if (!(user && learningPath)) {
        return;
      }

      setState({ isLoadingProgressForCourses: true });
      const progress = await getProgressForCourses(learningPath.coursesCollection.items.map((c) => c.sys.id));

      setState({
        progressForCourses: progress,
        isLoadingProgressForCourses: false,
      });
    };
